var translationJson = {
    "FOC": {
        "_COMMON_ACROSS_PAGES": {
            "AUDIO": {
                "CLOSE": "Close",
                "DISABLE_SUBTITLES": "Hide subtitles",
                "DISABLE_TRANSCRIPTS": "Hide transcripts",
                "DRAG": "Drag player",
                "ENABLE_SUBTITLES": "Show subtitles",
                "ENABLE_TRANSCRIPTS": "Show transcripts",
                "END_LOOP": "End loop",
                "ENTER_FULLSCREEN": "Enter fullscreen",
                "EXIT_FULLSCREEN": "Exit fullscreen",
                "EXIT_LOOP": "Stop loop",
                "FORWARD": "Forward 5s",
                "PAUSE": "Pause",
                "PLAY": "Play",
                "REWIND": "Rewind 5s",
                "SETTINGS": "Settings",
                "START_LOOP": "Start loop",
                "SLOW": "Slow",
                "NORMAL": "Normal",
                "FAST": "Fast",
                "SPEED": "Speed",
                "DURATION": "Duration",
                "CURRENT_TIME": "Current time",
                "SEEK": "Seek",
                "VOLUME":"Volume",
                "RESIZE": "Resize player"
            },
            "COOKIES_BANNER": {
                "ACCEPT": "Accept cookies",
                "PRIVACY_POLICY": "Privacy notice",
                "WEBSITE_USES_COOKIES": "This website uses cookies. For more information, please visit the "
            },
            "FOOTER": {
                "ACCESSIBILITY": "Accessibility",
                "CAMBRDIGE_UNIVERSITY_PRESS": "Cambridge University Press & Assessment 2022",
                "EXPERIENCE_BETTER_LEARNING": "Experience Better Learning",
                "HELP": "Help",
                "INSTITUTION_REQUEST": "Cambridge One for schools",
                "PRIVACY_POLICY": "Privacy notice",
                "TERMS_OF_USE": "Terms of use",
                "GUIDED_TOUR": "Get started tour",
                "FAQ": "FAQs",
                "SCREEN_READER": {
                    "TABLE_OF_CONTENT": "Table of Contents"
                }
            },
            "HEADER": {
                "LOGOUT": "Log out",
                "SCREEN_READER": {
                    "CAMBRDIGE_LOGO": "Cambridge One Home"
                },
                "MY_PROFILE": "My profile",
                "CUP_LOGO": "Cambridge University Press Logo"
            },
            "HOTSPOTS": {
                "ACTIVITY_LO": "Activity",
                "ANSWER_KEYS": "Answers",
                "AUDIO": "Audio",
                "DEFAULT": "Open hotspot",
                "EXTERNAL_LINK": "Open in new tab",
                "GAME": "Game",
                "GO_TO_PAGE": "Go to page",
                "PREDEFINED_ZOOM": "Double tap to zoom",
                "VIDEO": "Video",
                "NOTE": "Note",
                "PDF": "PDF"
            },
            "LO": {
                "CLOSE": "Close",
                "DRAG": "Drag this box",
                "EXPAND": "Enter fullscreen",
                "MINIMIZE": "Exit fullscreen",
                "MOBILE_MODAL_MESSAGE": "This content is designed for larger screens. Rotating your device may be easier to read"
            },
            "NOTES": {
                "ADD_NEW": "Add new",
                "ARE_YOU_SURE_CANCEL": "Are you sure you want to cancel?",
                "ARE_YOU_SURE_DELETE": "Are you sure you want to delete this note?",
                "BACK_TO_NOTES_PANEL": "Back to notes",
                "CANT_BE_UNDONE": "This action cannot be undone",
                "CLOSE": "Close",
                "CLOSE_NOTES": "Close",
                "COLLAPSE" : "Collapse",
                "COLOR_OPTIONS": "Choose colour",
                "DELETE_NOTE": "Delete",
                "EXPAND": "Expand",
                "FAILED_NOTES": "Failed to load notes, please try again",
                "GO_TO_PAGE": "Go to page",
                "KEEP": "Keep",
                "LOAD_NOTES": "Loading notes",
                "SAVE_NOTE": "Save",
                "UNSAVED_LOST": "Any unsaved edits will be lost",
                "YES_CANCEL": "Yes, cancel",
                "YES_DELETE": "Yes, delete",
                "NOTES_MESSAGE": "In this panel you can create, edit and pin both notes and links to the page",
                "TYPE_HERE": "Type here...",
                "NOTES": "My notes & links",
                "LOAD_FAIL": "Loading failed",
                "BLUE": "blue",
                "GREEN": "green",
                "ORANGE": "orange",
                "RED": "red",
                "INPUT_COLOUR": "click to input colour",
                "SELECT_COLOUR": "choose colour",
                "PIN_NOTE_PAGE": "Pin note to page",
                "CANCEL": "Cancel",
                "DO_SAVE_AND_PIN": "Do you want to save and pin your created note here?",
                "YES_SAVE_AND_PIN": "Yes, save and pin note",
                "NO_TAKE_BACK": "No, take me back",
                "PIN_INFO": "Click where you want the pin to appear on the page",
                "NOTES_MENU": {
                    "TITLE": "Notes menu",
                    "MOVE_PIN": "Move pin",
                    "REMOVE_PIN": "Remove pin from page",
                    "EDIT_NOTE": "Edit note",
                    "DELETE_NOTE": "Delete note",
                },
                "SCREEN_READER": {
                    "CLOSE_ICON_ALT": "Close my Notes"
                }
            },
            "SELECTION_BOX": {
                "CLOSE": "Close"
            },
            "TIMER": {
                "CLEAR": "Clear",
                "CLOSE": "Close",
                "COUNT_DOWN": "Count down",
                "COUNT_UP": "Count up",
                "DRAG": "Drag timer",
                "MUTE": "Mute",
                "PAUSE": "Pause",
                "PLAY": "Play",
                "RESET": "Reset",
                "UNMUTE": "Unmute"
            },
            "TIP_MODAL": {
                "COMMON": {
                    "SCREEN_READER": {
                        "HELP_ICON_ALT": "Information"
                    }
                },
                "SELECTION_TOOLS": {
                    "TITLE": "How to use this tool",
                    "DESCRIPTION": "Click and drag around an area you would like to focus on or hide",
                    "DONT_SHOW_AGAIN": "Don't show again",
                    "SCREEN_READER": {
                        "CLOSE_BTN_ARIA_LABEL": "Close"
                    }
                },
                "NOTES": {
                    "TITLE": "How to pin a note to the page",
                    "DESCRIPTION": "Click 'Pin note to page' and then click where you want it to appear",
                    "DONT_SHOW_AGAIN": "Don't show again",
                    "SCREEN_READER": {
                        "CLOSE_BTN_ARIA_LABEL": "Close"
                    }
                },
                "NOTES_LINKS": {
                    "TITLE": "How to use this tool",
                    "DESCRIPTION": "Write notes or paste external links, and keep them organised in one place",
                    "DONT_SHOW_AGAIN": "Don't show again",
                    "SCREEN_READER": {
                        "CLOSE_BTN_ARIA_LABEL": "Close"
                    }
                },
                "PDZ": {
                    "TITLE": "Double tap on an activity to enlarge it",
                    "DESCRIPTION": "",
                    "DONT_SHOW_AGAIN": "Don't show again",
                    "SCREEN_READER": {
                        "CLOSE_BTN_ARIA_LABEL": "Close"
                    }
                },
                "PDF": {
                    "TITLE": "Printable worksheets available in this unit",
                    "DESCRIPTION": "Click to open the printable worksheets in a new tab. You will be taken to the new tab automatically",
                    "DONT_SHOW_AGAIN": "Don't show again",
                    "SCREEN_READER": {
                        "CLOSE_BTN_ARIA_LABEL": "Close"
                    }
                }
            },
            "TOASTS": {
                "CHANGES_SAVED_AUTOMATICALLY": "Changes will be saved automatically",
                "FAILED_DRAWINGS": "Failed to load drawings, please try again",
                "FAILED_NOTES": "Failed to load notes, please try again",
                "LOAD_DRAWINGS": "Loading drawings",
                "SAVING_FAILED": "Saving failed. We'll keep trying",
                "HIDEBOX": {
                    "TITLE": "You've reached the maximum number of {{maskLimit}} hide boxes",
                    "DESCRIPTION": "To add more hide boxes to this page, first remove some existing ones"
                }
            },
            "TOC": {
                "CLOSE_TOC": "Close",
                "COLLAPSE": "Collapse",
                "EXPAND": "Expand",
                "JUMP_TO_PAGE": "Open",
                "PAGE_LABEL": "Page",
                "PAGE_NOT_EXIST": "Page does not exist",
                "TOGGLE_EBOOK": "Change course material",
                "ASSIGNMENT_MODAL": "Create assignment",
                "SCREEN_READER": {
                    "CLOSE_ICON_ALT": "Close Table of Contents"
                },
                "RESOURCE_BANK": "Teacher's Resources"
            },
            "TOOLBAR": {
                "CLEAR": "Clear",
                "CLOSE_JUMP_TO_PAGE": "Close 'Go to page' option",
                "DOUBLE_PAGE": "Double page",
                "DRAWING_TOOLS": "Drawing tools",
                "FIT_TO_SCREEN": "Fit to screen",
                "FIT_TO_WIDTH": "Fit to width",
                "FIT_TO_HEIGHT": "Fit to height",
                "GO_TO_PAGE": "Go to page",
                "HIGHLIGHTER": "Highlighter",
                "HIGHLIGHTER_COLOR_OPTIONS": "Highlighter colour",
                "HIGHLIGHTER_WIDTH_OPTIONS": "Highlighter width",
                "HOME": "Home",
                "INVERT": "Move toolbar",
                "JUMP_PAGE": "Jump to page",
                "MASK": "Hide selection",
                "NEXT_PAGE": "Next page",
                "NOTES": "Notes",
                "OPEN_JUMP_TO_PAGE": "Open 'Go to page' option",
                "PEN": "Drawing tools",
                "PEN_COLOR_OPTIONS": "Pen colour",
                "PEN_WIDTH_OPTIONS": "Pen width",
                "PREVIOUS_PAGE": "Previous page",
                "REDO": "Redo",
                "REMOVE_ALL": "Eraser",
                "SAVED": "Saved",
                "SAVED_TOOLTIP": "We automatically save your changes every 20 seconds",
                "SAVING": "Saving",
                "SAVING_FAILED": "Saving failed, please try again",
                "SAVING_FAILED_TOOLTIP": "Your changes could only be saved on this device\r\n",
                "SAVING_TOOLTIP": "Saving, please don't leave this page",
                "SELECTION_TOOLS": "Show/Hide selection",
                "SINGLE_PAGE_VIEW": "Single page view",
                "SPOTLIGHT": "Show selection",
                "TIMER": "Timer",
                "TOC": "Contents",
                "TOOLS": "Tools",
                "UNDO": "Undo",
                "ZOOM": "Zoom options",
                "ZOOM_IN": "Zoom in",
                "ZOOM_OUT": "Zoom out"
            },
            "VIDEO": {
                "CLOSE": "Close",
                "DECREASE_TRANSCRIPT_SIZE": "Reduce font size",
                "DISABLE_SUBTITLES": "Hide subtitles",
                "DISABLE_TRANSCRIPTS": "Hide transcripts",
                "DRAG": "Drag player",
                "ENABLE_SUBTITLES": "Show subtitles",
                "ENABLE_TRANSCRIPTS": "Show transcripts",
                "ENTER_FULLSCREEN": "Enter fullscreen",
                "EXIT_FULLSCREEN": "Exit fullscreen",
                "FORWARD": "Forward 5s",
                "INCREASE_TRANSCRIPT_SIZE": "Increase font size",
                "PAUSE": "Pause",
                "PLAY": "Play",
                "REWIND": "Rewind 5s",
                "SETTINGS": "Settings",
                "SLOW": "Slow",
                "NORMAL": "Normal",
                "FAST": "Fast",
                "SPEED": "Speed",
                "DURATION": "Duration",
                "CURRENT_TIME": "Current time",
                "SEEK": "Seek",
                "VOLUME":"Volume",
            }
        },
        "CREATE_USER_ANALYTICS": {
            "WELCOME_TEXT": "Welcome to your Cambridge One",
            "DESCRIPTION_TEXT": "We’re setting up the learning materials for you",
        },
        "DESKTOP": {
            "GUIDED_TOUR":{
                "WELCOME_HEADING": "Welcome to the Cambridge One Desktop App",
                "WELCOME_DESC": "Now you can access eBooks and Presentation Plus offline",
                "DOWNLOAD_HEADING": "Download an eBook or Presentation Plus",
                "DOWNLOAD_DESC": "You'll then be able to access it offline",
                "ONLINE_HEADING": "Work online or offline",
                "ONLINE_DESC": "We'll synchronise the work you do offline in your Cambridge One account when you're next online",
                "HELP_HEADING": "Find out more about the app",
                "HELP_DESC": "Replay our Get started tour or visit our FAQs page",
                "BACK": "Back",
                "NEXT": "Next",
                "DONE": "Done"
            },
            "ASSIGNMENT_MODAL": {
                "DEFAULT_TITLE": "Select the class for which you want to create assignments",
                "ERROR_TITLE": "This material is not linked to any class",
                "NO_CLASS_MESSAGE": "Create a class in your Cambridge One account dashboard and add students and learning materials to it. You can then assign activities to your students",
                "NO_MATERIAL_MESSAGE": "Add learning materials to a class in your Cambridge One account dashboard. You can then assign activities to your students",
                "CREATE_CLASS": "Create a class",
                "ADD_MATERIALS": "Add materials",
                "TAKE_ME_TO_ASSIGNMENT": "Take me to assignments",
                "TAKE_ME_TO_DASHBOARD": "Take me to my dashboard",
                "CANCEL": "Cancel",
                "GO_BACK": "Go back",
                "CLOSE": "Close"
            },
            "CANCEL_DOWNLOAD_MODAL": {
                "DESC": "This means you won't be able to access this material offline",
                "HEADING": "Are you sure you want to cancel this download?",
                "KEEP": "Keep",
                "REMOVE": "Yes, cancel"
            },
            "DOWNLOAD_SPACE_ERROR_MODAL": {
                "DESC1": "Free up ",
                "DESC2": " on your computer to download ",
                "HEADING": "Not enough free space",
                "OK": "Ok",
            },
            "DOWNLOADING_ERROR_MODAL": {
                "DESC": "We were unable to download {{bookName}}, please try again. If the problem persists, click on Help to read our Cambridge One Desktop App FAQs",
                "HEADING": "Download not successful",
                "OK": "Ok",
            },
            "CLOSE_DIALOG": {
                "DOWNLOAD_IN_PROGRESS": "Download in progress",
                "HEADING": "Are you sure you want to exit the Desktop App?",
                "NO": "No, go back",
                "QUIT_MSG": "Some of your content is being downloaded and/or updated, and you will not have access to it offline until your content is up to date",
                "YES": "Yes, exit",
            },
            "DOWNLOAD_VALIDATION_MODAL": {
                "HEADING": "Download failed",
                "OK": "OK",
                "VERSION_MISMATCH": "The content you are trying to download is not available at the moment. Please try again in a few minutes."
            },
            "ERROR": {
                "BACK_TO_DASHBOARD": "Back to dashboard",
                "ERROR_SOMETHING_WRONG": "Something went wrong",
                "ERROR_UNEXPECTED_ERROR_DESCRIPTION_1": "Please restart the app",
                "OOPSIE": "Sorry!"
            },
            "APP_ASSET_ERROR_MODAL": {
                "MODAL_TITLE": "This book is not complete",
                "MODAL_BODY_CONTENT_1": "Some of the content required to view this book has failed to download",
                "MODAL_BODY_CONTENT_2_OFFLINE": "Please delete this book and download it again to enable offline access",
                "MODAL_BODY_CONTENT_3_ONLINE": "The book uses downloaded assets which seem to be missing or corrupted. Please delete this downloaded book to view it.",
                "MODAL_BUTTON_1_OFFLINE": "Ok",
            },
            "LAUNCH": {
                "FORM": {
                    "ACCOUNT_REG": "Don't have an account yet?",
                    "FORGOT_PASSWORD": "Forgotten your password?",
                    "INVALID_CREDENTIALS": "invalid loginID or password",
                    "LOGIN": "Log in",
                    "LOGINID": "Login",
                    "PASSWORD": "Password",
                    "REQUIRED_FIELD": "This field is required",
                    "USERNAME_PLACEHOLDER": "Enter username or email address",
                    "PASSWORD_PLACEHOLDER": "Enter your password"
                },
                "INSTRUCTION": {
                    "OFFLINE": "If you are logging in to this app for the first time, make sure you are connected to the internet",
                    "ONLINE": "Please enter your credential to login"
                },
                "OFFLINE": "No network Connection",
                "OFFLINE_BTN": "Enter Offline Mode",
                "OFFLINE_ERROR": {
                    "MESSAGE": "To access downloaded materials offline, you first need to log in with an internet connection",
                    "TITLE": "Sorry, you are currently offline"
                },
                "ONLINE": "You are currently online",
                "STATUS": {
                    "OFFLINE": "offline",
                    "ONLINE": "online"
                },
                "TITLE": "Cambridge One FOC App",
                "USER": {
                    "USERS": "Shared computer",
                    "USERS_LIST_AVAILABLE_MSG": "You're sharing this computer with other people who have previously logged in:",
                    "USERS_LIST_NOT_AVAILABLE_MSG": "Once you've logged in, your details will show here"
                }
            },
            "LEARNER": {
                "DASHBOARD": {
                    "BOOK_INFO": "Course information",
                    "BOOK_OPTIONS": "Options",
                    "BOOK_REMOVE": "Remove download",
                    "CANCEL": "Cancel",
                    "DOWNLOAD": "Download",
                    "DOWNLOADED": "Downloaded",
                    "FIRSTNAME": "Learner",
                    "HI": "Hi",
                    "MY_PRIVATE_LEARNING": "My independent learning",
                    "OFFLINE": "No network Connection",
                    "ONLINE": "You are currently online",
                    "PAUSE": "Pause",
                    "RESUME": "Resume",
                    "SCREEN_READER": {
                        "LAUNCH_PRODUCT": "Open materials"
                    },
                    "WORKBOOK": "Workbook",
                    "COMING_SOON": "Coming Soon",
                    "BOOK_NOT_YET_PUBLISHED": "This ebook is not yet published",
                    "EXPIRED": "Expired",
                    "ACTIVATE_TEXT": "Now you can start using your eBooks on the app. You’ll need to activate them online first, or ask your teacher about class eBooks you can access",
                    "ACTIVATE_BTN": "Activate",
                    "CALCULATING_SIZE": "Calculating size...",
                    "DOWNLOAD_QUEUED": "Queued download..."
                }
            },
            "LOGOUT_MODAL": {
                "DESC_OFFLINE": "You won't be able to access your downloaded materials offline",
                "DESC_ONLINE": "You won't be able to access your downloaded materials offline. We only recommend logging out if you're using a shared device",
                "GO_BACK": "No, go back",
                "HEADING": "Are you sure you want to log out?",
                "LOGOUT": "Yes, log out",
                "DOWNLOAD": "Some of your content is being downloaded and/or updated, and you won’t be able to access your downloaded materials offline if you log out"
            },
            "REMOVE_DOWNLOAD_MODAL": {
                "DESC": "This item will be removed from the downloads on your device. You will still be able to access it online",
                "HEADING": "Are you sure?",
                "KEEP": "Keep",
                "REMOVE": "Yes, remove "
            },
            "APP_UPDATE_ERROR_MODAL": {
                "IMAGE_ALT_TEXT": "Cross",
                "MODAL_TITLE": "Download not successful",
                "CLOSE": "Close",
                "MODAL_MESSAGE_1": "Please relaunch the Cambridge One Desktop App to try again",
                "MODAL_MESSAGE_2": "There is not enough free space on your computer to complete the download. Please free 300 MB and relaunch the Cambridge One Desktop App",
                "EXIT_APP": "Close"
            },
            "TEACHER": {
                "DASHBOARD": {
                    "ALL_COURSES": "All course material",
                    "CANCEL": "Cancel",
                    "CLASSES": "My classes",
                    "CLEAR": "Clear",
                    "DOWNLOAD": "Download",
                    "DOWNLOADED": "Downloaded",
                    "HI": "Hi",
                    "INSTRUCTION": {
                        "OFFLINE_NO_PRODUCT": "You haven’t downloaded any course material yet. When you do it will appear here"
                    },
                    "LIBRARY": "My library",
                    "NO_SEARCH_RESULTS": "No search results",
                    "PAUSE": "Pause",
                    "RESUME": "Resume",
                    "SEARCH_PLACEHOLDER": "Search for course materials",
                    "COMING_SOON": "Coming Soon",
                    "BOOK_NOT_YET_PUBLISHED": "This ebook is not yet published",
                    "EXPIRED": "Expired",
                    "ACTIVATE_TEXT": "Now you can start accessing Presentation Plus or eBooks on the app. You’ll need to activate them online first",
                    "ACTIVATE_BTN": "Activate",
                    "CLASS_ENDED": "Class ended",
                    "CALCULATING_SIZE": "Calculating size...",
                    "DOWNLOAD_QUEUED": "Queued download..."

                },
                "PRODUCT_DETAIL": {
                    "BACK_TO_COURSE": "Back to course",
                    "CANCEL": "Cancel",
                    "DELETE_DOWNLOAD": "Delete download",
                    "DOWNLOAD": "Download",
                    "DOWNLOADED": "Downloaded",
                    "MATERIALS": "Materials",
                    "NO_COMPONENT_MSG": "This title doesn't have any learning materials yet",
                    "PAUSE": "Pause ",
                    "PRODUCT_MENU": "Show product menu options",
                    "RESUME": "Resume ",
                    "START_COURSE": "Start course",
                    "AVAILABLE_OFFLINE": "Available offline",
                    "NOT_DOWNLOADED": "Not downloaded",
                    "OFFLINE_MESSAGE": "Download this when you’re online to access it offline later",
                    "OFFLINE_TOOLTIP": "Download this when you’re online to access it offline",
                    "COMING_SOON": "Coming Soon",
                    "BOOK_NOT_YET_PUBLISHED": "This ebook is not yet published",
                    "EXPIRED": "Expired",
                    "EXPIRED_EBOOK": "Expired eBook",
                    "EXPIRES": "Expires",
                    "CALCULATING_SIZE": "Calculating size...",
                    "UP_TO_DATE": "Content up to date",
                    "DOWNLOAD_QUEUED": "Queued download..."
                }
            },
            "OFFLINE_ERROR_MODAL": {
                "ONLINE_MESSAGE": "We noticed your internet connection was restored. You will need to log in again to synchronise your changes",
                "OFFLINE_MESSAGE": "Internet connection lost. You now have access to the offline version. Any changes you make can be synchronised when your internet connection is restored and you log in again"
            },
            "AUTO_UPDATE": {
                "UPDATES": "Working on updates...",
                "RELAUNCH": "The app will close and relaunch automatically when updates are complete"
            }
        },
        "LO": {
            "TEACHER": {
                "ACTIVITYVIEW": {
                    "CHECK": "Check",
                    "NEXT": "Next",
                    "NEXT_ACTIVITY": "NEXT ACTIVITY",
                    "PREVIOUS": "Previous",
                    "REVIEW": "REVIEW",
                    "SHOW_ALL_ANSWERS": "Show answers"
                }
            },
            "RESULT_SCREEN": {
                "YOU_SCORED":"You scored",
                "MARKS_OUT_OF":"out of",
                "EXIT": "Exit activity",
                "REVIEW": "Review answers",
                "TRY_AGAIN": "Start again"
            }
        }
    },
    "HTML_META": {
        "FOC_EBOOK": {
            "DESCRIPTION": "Cambridge One is a mobile-friendly learning environment for English language learners and teachers.",
            "TITLE": "Ebook | Product"
        },
        "FOC_DESKTOP": {
            "DESCRIPTION": "Cambridge One is a mobile-friendly learning environment for English language learners and teachers.",
            "TITLE": "Cambridge One Desktop App | Cambridge University Press"
        },
        "MAIN": {
            "DESCRIPTION": "Cambridge One is a mobile-friendly learning environment for English language learners and teachers.",
            "TITLE": "Cambridge One | Cambridge University Press"
        }
    }
}
module.exports = translationJson;
